import { render, staticRenderFns } from "./femaleoutline.vue?vue&type=template&id=2d465545&scoped=true&"
import script from "./femaleoutline.vue?vue&type=script&lang=js&"
export * from "./femaleoutline.vue?vue&type=script&lang=js&"
import style0 from "./femaleoutline.vue?vue&type=style&index=0&id=2d465545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d465545",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d465545')) {
      api.createRecord('2d465545', component.options)
    } else {
      api.reload('2d465545', component.options)
    }
    module.hot.accept("./femaleoutline.vue?vue&type=template&id=2d465545&scoped=true&", function () {
      api.rerender('2d465545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/femaleoutline.vue"
export default component.exports